"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
function getMainSpecifiersBySportId(sportId) {
    switch (sportId) {
        case 'ice_hockey':
        case 'esports_ice_hockey': {
            return [constants_1.SpecifierName.periodnr, constants_1.SpecifierName.overtimenr];
        }
        case 'football':
        case 'esports_fifa':
        case 'handball':
        case 'futsal': {
            return [constants_1.SpecifierName.halfnr, constants_1.SpecifierName.overtimenr];
        }
        case 'esports_baseball':
        case 'baseball': {
            return [constants_1.SpecifierName.inningnr];
        }
        case 'american_football': {
            return [constants_1.SpecifierName.halfnr, constants_1.SpecifierName.quarternr];
        }
        case 'basketball':
        case 'esports_basketball': {
            return [
                constants_1.SpecifierName.quarternr,
                constants_1.SpecifierName.halfnr,
                constants_1.SpecifierName.overtimenr,
            ];
        }
        case 'tennis':
        case 'table_tennis':
        case 'esports_tennis':
        case 'volleyball':
        case 'esports_volleyball':
        case 'beach_volleyball':
        case 'badminton': {
            return [constants_1.SpecifierName.setnr];
        }
        case 'esports_artifact':
        case 'esports_battlegrounds':
        case 'esports_fortnite':
        case 'esports_call_of_duty_warzone': {
            return [constants_1.SpecifierName.gamenr];
        }
        case 'esports_dota_2':
        case 'esports_counter_strike':
        case 'esports_rainbow_six':
        case 'esports_call_of_duty':
        case 'esports_starcraft':
        case 'esports_starcraft_1':
        case 'esports_world_of_tanks':
        case 'esports_hearthstone':
        case 'esports_heroes_of_the_storm':
        case 'esports_league_of_legends':
        case 'esports_overwatch':
        case 'esports_vainglory':
        case 'esports_warcraft_3':
        case 'esports_rocket_league':
        case 'esports_smite':
        case 'esports_soccer_mythical':
        case 'esports_halo':
        case 'esports_crossfire':
        case 'esports_street_fighter_5':
        case 'esports_king_of_glory':
        case 'esports_valorant':
        default: {
            return [constants_1.SpecifierName.mapnr];
        }
    }
}
exports.default = getMainSpecifiersBySportId;
//# sourceMappingURL=getMainSpecifiersBySportId.js.map